import { useDispatch as _useDispatch } from 'react-redux';

export default _useDispatch.withTypes();
